import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.universal.people',
    'package:data.universal.personnel',
    'resource:data.dimensions.outcomeAssignees.entities.assignee.attributes.isAccountable',
    'resource:data.dimensions.outcomeAssignees.entities.assignee.attributes.isConsulted',
    'resource:data.dimensions.outcomeAssignees.entities.assignee.attributes.isInformed',
    'resource:data.dimensions.outcomeAssignees.entities.assignee.attributes.isResponsible',
    'resource:data.dimensions.outcomeAssignees.entities.assignee.attributes.outcome',
    'resource:data.dimensions.outcomeAssignees.entities.assignee.attributes.employee',
    'resource:data.dimensions.outcomeAssignees.entities.assignee',
    'resource:data.dimensions.outcomeAssignees',
    'resource:data.dimensions.outcomes.entities.mission',
    'resource:data.dimensions.outcomes.entities.goal',
    'resource:data.dimensions.outcomes.entities.objective',
    'resource:data.dimensions.outcomes',
    'resource:data.dimensions.outcomeExternalSources.entities.source.attributes.outcome',
    'resource:data.dimensions.outcomeExternalSources.entities.source.attributes.url',
    'resource:data.dimensions.outcomeExternalSources.entities.source.attributes.system',
    'resource:data.dimensions.outcomeExternalSources.entities.source',
    'resource:data.dimensions.outcomeExternalSources',
    'resource:data.dimensions.outcomeMetrics.entities.metric.attributes.outcome',
    'resource:data.dimensions.outcomeMetrics.entities.metric.attributes.value',
    'resource:data.dimensions.outcomeMetrics.entities.metric.attributes.max',
    'resource:data.dimensions.outcomeMetrics.entities.metric.attributes.goal',
    'resource:data.dimensions.outcomeMetrics.entities.metric',
    'resource:data.dimensions.outcomeMetrics',
  ],
  description: 'High-level results we are pursuing',
  name: 'Outcomes',
} as const satisfies core.quiver.Package
